import React from 'react';
import ContactContent from '@/components/landing/home/ContactContent';
import Footer from '@/components/layout/landing/Footer';
import APIServices from '@/apiUtils/APIServices';
import { GetStaticProps } from 'next';
import SEO from '@/components/landing/seo';
import NavbarNew from '@/components/layout/landing/NavbarNew';

function Contact(props) {
  return (
    <>
      <SEO
        meta_title={'Contact Us | Learnsic'}
        meta_description={props?.data?.data?.connect}
        meta_keywords={'contact us, learnsic, learnsic address'}
        photo={''}
        canonical="contact"
      />
      <NavbarNew />
      <ContactContent office={props?.data?.data?.office} />
      <Footer />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const { data, success } = await new APIServices(`/info/`).get();
  return {
    props: {
      data: success ? data : {},
    },
    revalidate: 300,
  };
};

export default Contact;
